import { render, staticRenderFns } from "./PHeard.vue?vue&type=template&id=1b5fb051&scoped=true"
import script from "./PHeard.vue?vue&type=script&lang=js"
export * from "./PHeard.vue?vue&type=script&lang=js"
import style0 from "./PHeard.vue?vue&type=style&index=0&id=1b5fb051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5fb051",
  null
  
)

export default component.exports